module.exports = __webpack_public_path__ + "img/edit.2e6c15b2.svg";